var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm flex"},[_c('input',{staticClass:"w-5 h-5",attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.checked},on:{"input":function($event){return _vm.$emit('checked', $event.target.checked)}}}),_c('label',{staticClass:"block ml-2",attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }